import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=31238cd1&scoped=true&"
var script = {}
import style0 from "./Banner.vue?vue&type=style&index=0&id=31238cd1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31238cd1",
  null
  
)

export default component.exports